export default "__VITE_ASSET__Dv9fcYqR__"